import { useRecoilState, useRecoilValue } from 'recoil';

import {
	carMakeState,
	carModelState,
	carColorState,
	carMakeValidationState,
	carModelValidationState,
	carColorValidationState
} from '../../atoms';
import makesJson from '../../assets/makes.json';
import makesModels from '../../assets/makes-models.json';

import { FilterSelect } from '../../../components/FilterSelect';
import { ColorPicker } from '../../../components/ColorPicker';

const makes = makesJson as (keyof typeof makesModels)[];

export type CarDetailsProps = {
	isActive: boolean;
};

const colorList = [
	'White',
	'Gray',
	'Black',
	'Red',
	'Orange',
	'Yellow',
	'Green',
	'Blue',
	'Purple'
];

const isMake = (t: unknown): t is keyof typeof makesModels =>
	typeof t === 'string' && makes.includes(t as keyof typeof makesModels);

export const CarDetails: React.FC<CarDetailsProps> = ({ isActive }) => {
	const [make, setMake] = useRecoilState(carMakeState);
	const carMakeValidation = useRecoilValue(carMakeValidationState);

	const [model, setModel] = useRecoilState(carModelState);
	const carModelValidation = useRecoilValue(carModelValidationState);

	const [carColor, setCarColor] = useRecoilState(carColorState);
	const { validation, ignoreTouched } = useRecoilValue(
		carColorValidationState
	);

	return (
		<div
			className="checkout-car-details car-details pb-3"
			style={{ maxWidth: 200 }}
		>
			<FilterSelect
				items={makes}
				label="Vehicle Make"
				placeHolder="Ford, Subaru, etc."
				setIndex={index =>
					setMake(index >= 0 ? makes[index] : undefined)
				}
				tabIndex={isActive ? undefined : -1}
				className="pb-3 checkout-car-details-make"
				validation={carMakeValidation}
				initialIndex={makes.indexOf(make as keyof typeof makesModels)}
			/>

			{make && (
				<FilterSelect
					items={isMake(make) ? makesModels[make] : []}
					label="Vehicle Model"
					placeHolder="Focus, Outback, etc."
					setIndex={index =>
						setModel(
							isMake(make) ? makesModels[make][index] : undefined
						)
					}
					tabIndex={isActive ? undefined : -1}
					className="pb-3 checkout-car-details-model"
					validation={carModelValidation}
					initialIndex={makesModels[
						make as keyof typeof makesModels
					].indexOf(model ?? '')}
				/>
			)}

			{model && (
				<div className="checkout-car-details-color">
					<div className="car-details-item p-0 position-relative">
						<label
							className="input-label p-0 mb-1 mr-3"
							htmlFor="car-details-color"
							style={{ width: 105 }}
						>
							Vehicle Color:
						</label>

						<span className="car-details-color-text mb-1">
							{carColor}
						</span>
					</div>

					<ColorPicker
						currentColor={carColor}
						colorList={colorList}
						clickHandler={setCarColor}
						isActive={isActive}
					/>

					{validation && ignoreTouched && (
						<div className="text-danger">{validation}</div>
					)}
				</div>
			)}
		</div>
	);
};
